/**
 * incoming-message-map.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import {
    IncomingMessage,
    Message,
    MessageConstructor,
    MessageTag,
    Tagged,
    ValidatingClass
} from "../messages/general/";

import * as Admin from "../messages/admin/";
import * as Aggregation from "../messages/aggregation/";
import * as Algorithms from "../messages/algorithms/";
import * as Auth from "../messages/auth/";
import * as Collaboration from "../messages/collaboration/";
import * as Contexts from "../messages/context-management/";
import * as Debug from "../messages/debug/";
import * as Export from "../messages/export/";
import * as General from "../messages/general/";
import * as Groups from "../messages/group-management/";
import * as Metadata from "../messages/metadata/";
import * as Reminders from "../messages/reminders/";
import * as Schemas from "../messages/schemas/";
import * as Search from "../messages/search/";
import * as Subjects from "../messages/subjects/";
import * as Watchlists from "../messages/watchlists/";

/**
 * The incoming message map provides constructors for *incoming* messages, which
 * are expected to do their own demarshalling from JSON, based on their tags.
 * The classes are automatically collected from all message modules among those
 * that self-nominate with the `selfValidates` property.
 *
 * The usage of a map here allows values to be injected and overriden with
 * alternate constructors, as needed for debugging or on-the-fly manipulation
 * of values.
 */
export const INCOMING_MESSAGE_MAP : Map<MessageTag, ValidatingClass> =
    new Map();

export const OUTGOING_MESSAGE_MAP : Map<MessageTag, MessageConstructor> =
    new Map();

[].concat.apply([],
        [
            Admin,
            Aggregation,
            Algorithms,
            Auth,
            Collaboration,
            Contexts,
            Debug,
            Export,
            General,
            Groups,
            Metadata,
            Reminders,
            Schemas,
            Search,
            Subjects,
            Watchlists
        ].map((mod : any) => Object.values(mod))
    ).filter((imported : any) =>
        (typeof imported === "function") && (Number.isInteger(imported.tag)))
    .forEach((imported : MessageConstructor) => {
        if (imported.selfValidates === true)
        {
            INCOMING_MESSAGE_MAP.set(imported.tag, imported as ValidatingClass);
        }
        else
        {
            OUTGOING_MESSAGE_MAP.set(imported.tag, imported);
        }
    });

console.info("incoming message map ⤵\n", INCOMING_MESSAGE_MAP);
console.info("outgoing message map ⤵\n", OUTGOING_MESSAGE_MAP);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/validation/incoming-message-map.ts